module.exports = __webpack_public_path__ + "static/img/dz-banner-.17ef721.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dz-banner-.png
// module id = 2Ku4
// module chunks = 18